

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface VaccineBrandDetParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface VaccineBrandDet {
    id?: any;
    sno?:number;
    medicineId:any;
    tenantId: any;
    branchId: any;
    isActive:string;
    
    parameters?: VaccineBrandDetParameter[];
    links?: any;
}


export abstract class VaccineBrandDetData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<VaccineBrandDet[]>;
    abstract create(url: string, data: VaccineBrandDet): Observable<VaccineBrandDet[]>;
    abstract update(url: string, data: VaccineBrandDet): Observable<VaccineBrandDet>;
    abstract delete(url: string): Observable<any>;
}
